import React from "react";
import {Bollet, StepsContainer} from "./style";
import {PURCHASE_STEPS_TYPE_TEXT} from "../../../../constants/purchase";

export const Steps = props => {
  const active = true;
  const { removableItemType, formStep } = props;
  const index = parseInt(formStep);
  return (
    <StepsContainer>
      {PURCHASE_STEPS_TYPE_TEXT.map((typeText, i) => {
        if (!(typeText.canHide && typeText.type === removableItemType))
          return (
            <Bollet
              key={i}
              StepsContainer
              active={index === typeText.type ? active : false}
              visited={
                index === typeText.type ? !active : index > typeText.type
              }
            >
              <span>{typeText.text}</span>
            </Bollet>
          );
        else
          return undefined;
      })}
      {/*{(props.showCreateProject || index === 1) && (*/}
      {/*  <Bollet*/}
      {/*    StepsContainer*/}
      {/*    active={index === 1 ? active : false}*/}
      {/*    visited={index === 1 ? !active : index > 1}*/}
      {/*  >*/}
      {/*    <span>ایجاد پروژه</span>*/}
      {/*  </Bollet>*/}
      {/*)}*/}
      {/*<Bollet*/}
      {/*  StepsContainer*/}
      {/*  active={index === 2 ? active : false}*/}
      {/*  visited={index === 2 ? !active : index > 2}*/}
      {/*>*/}
      {/*  <span>انتخاب طرح</span>*/}
      {/*</Bollet>*/}
      {/*<Bollet*/}
      {/*  StepsContainer*/}
      {/*  active={index === 3 ? active : false}*/}
      {/*  visited={index === 3 ? !active : index > 3}*/}
      {/*>*/}
      {/*  <span>تایید طرح</span>*/}
      {/*</Bollet>*/}
      {/*<Bollet*/}
      {/*  StepsContainer*/}
      {/*  active={index === 4 ? active : false}*/}
      {/*  visited={index === 4 ? !active : index > 4}*/}
      {/*>*/}
      {/*  <span>پرداخت نهایی</span>*/}
      {/*</Bollet>*/}
    </StepsContainer>
  );
};
